





































































































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { IInternetSources as IIS } from "@/@types/_settings/internet-sources";
import { languages } from "@/config/languags.config.json";
import { ILocale } from "@/@types/locale";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import draggable from "vuedraggable";

@Component({
  components: {
    StandartModal,
    SubmitResetButtonGroop,
    ChangeDeliteButtons,
    draggable,
    BSwitch,
  },
})
export default class InternetSources extends Vue {
  @Prop({ type: Array, default: () => [] }) sources!: Array<IIS>;
  languages = languages;
  locale = languages[0];
  showForm = false;
  dragging = false;
  enabled = true;

  names: ILocale = {};
  name = "";
  active = true;

  get source(): IIS {
    return {
      _id: "",
      name: this.names,
      active: this.active,
      src: { icon: "" },
    };
  }

  @Watch("name")
  changeName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("locale")
  updateName(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("addSource", this.source);
    this.onReset();
    this.showForm = false;
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.active = false;
  }
}
